import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Header, Select, Table, Button } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Import CSS for datepicker
import { operatorPerformanceType } from '../../../app/models/Restoration';
import { useStore } from '../../../app/stores/store';
import DynamicTableCSVReport from '../../DynamicTable/DynamicTableCSVReport';
import LoadingComponent from '../../../app/layout/LoadingComponent';
interface TableData extends operatorPerformanceType {}
interface TableComponentProps {
  name:string;
  dateBasedApiCall: (fromDate?: string,toDate?: string,clusterEmployeeId?:string)=>void;
  DateInput:boolean,
  DualInut:boolean,
  downloadName:string,
  clusterEmployeeIdFilter?:boolean,
}
const TableComponent: React.FC<TableComponentProps> = ({name,dateBasedApiCall,DateInput,DualInut,downloadName,clusterEmployeeIdFilter}) => {
  const { RestorationStore } = useStore();
  const currentDate = new Date(); // Get current date
const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); // Set it to the first day of the month
  const [fromDate, setFromDate] = useState<Date>(clusterEmployeeIdFilter ? firstDayOfMonth : new Date());
  const [toDate, setToDate] = useState<Date>(new Date());
  const [loadData, setLoadData] = useState<TableData[]>([]);
  const [tableEnable, setTableEnable] = useState<boolean>(false);
  const [reportColumns, setReportColumns] = useState<string[]>([]);
  const [reportTypeValue, setReportTypeValue] = useState<string>('');
  const [assingTitleCode, setAssignTitleCode] = useState<
  { key: string; text: string; value: string }[]
>([]);
  const[fileName,setFileName] = useState('');
  const [clusterEmpDetails,setClusterEmpDetails] = useState<
  {options:{ key: string; text: string; value: string }[],value:string}
>({options:[],value:''});
 
  const reportTypeOptions = [
    { key: 1, text: 'Title Wise', value: 'Title Wise' },
    { key: 2, text: 'Date Wise', value: 'Date Wise' },
  ];

  useEffect(()=>{
   if(clusterEmployeeIdFilter){
    dateBasedDataLoad();
   }
   // eslint-disable-next-line
  },[])
  useEffect(()=>{
  if(clusterEmployeeIdFilter && RestorationStore.ClusterHeadEmployeeID.length > 0){
    const empOptions = RestorationStore.ClusterHeadEmployeeID.map(
      (empOptions: string) => {
        return {
          key: empOptions,
          text: empOptions,
          value: empOptions,
        };
      },
    );
    setClusterEmpDetails({
      ...clusterEmpDetails,
      options: empOptions
    })
  }
  // eslint-disable-next-line
  },[RestorationStore.ClusterHeadEmployeeID])
  useEffect(()=>{
    if(!clusterEmployeeIdFilter){
      setFileName(downloadName);
    }
    // eslint-disable-next-line
  },[downloadName])
  useEffect(() => {
    const loadTitleCode = RestorationStore.titleCodeData.map(
      (titleCodeList: string) => {
        return {
          key: titleCodeList,
          text: titleCodeList,
          value: titleCodeList,
        };
      },
    );
    setAssignTitleCode(loadTitleCode);
    // eslint-disable-next-line
  }, [reportTypeValue]);
  const HandleClear = ()=>{
    setLoadData([]);
    setTableEnable(false)
    setReportColumns([])
  }
  const handleNoDateInput = async ()=>{
      await dateBasedApiCall();
      if(RestorationStore.reportDetails.length > 0){
        setLoadData(RestorationStore.reportDetails);
        setTableEnable(true);
        setReportColumns(Object.keys(RestorationStore.reportDetails[0]));
      }
      else{
        toast.error('Sorry, No Data')
        HandleClear();
      }
  }
  useEffect(()=>{
    if(!DateInput && !DualInut){
    handleNoDateInput();
    }
    HandleClear();
     // eslint-disable-next-line
  },[])
  const formattedDate = (date:any)=>{
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
const day = String(date.getDate()).padStart(2, '0');
const year = date.getFullYear();

    return `${month}-${day}-${year}`
  }
  const dateBasedDataLoad = async () => {
    try {
      setFileName('')
      const differenceInMs = Math.abs(toDate.getTime() - fromDate.getTime());
    const differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24) + 1);
    if (differenceInDays > 31) {
      toast.warning('Please select a date range of 31 days or less');
      return;
    }
    const start = formattedDate(fromDate);
    const end = formattedDate(toDate)
    const  changeDateFormat = (dateString:any) => {
      var parts = dateString.split('-');
      var newDateString = parts[1] + '-' + parts[0] + '-' + parts[2];
      return newDateString;
  }
      setFileName(`${downloadName}${clusterEmpDetails.value ==='' ? '' :`_${clusterEmpDetails.value}`}_${changeDateFormat(start)} - ${changeDateFormat(end)}`)
      await dateBasedApiCall(
        start,
        end,
        clusterEmployeeIdFilter ? clusterEmpDetails.value : undefined,
      );
      if(RestorationStore.reportDetails.length > 0){
        setLoadData(RestorationStore.reportDetails);
        setTableEnable(true);
        setReportColumns(Object.keys(RestorationStore.reportDetails[0]));
      }
      else{
        HandleClear();
        !clusterEmployeeIdFilter && toast.error('Sorry, No Data')
      }
    } catch (error) {
      toast.error('Something went wrong. Please try again!');
      setTableEnable(false);
    }
  };

  const reportTypeAssign = async (event: any, data: any) => {
    const { value } = data;
    let reportType = reportTypeOptions.find((option) => option.value === value);
    if (reportType) {
      setLoadData([]);
      setReportTypeValue(reportType.value);
    }
  };
  const titleBasedDataLoad = async (title:string)=>{
    setFileName('')
    await RestorationStore.productionTitleWiseReport(title);
    if(RestorationStore.reportDetails.length > 0){
      setLoadData(RestorationStore.reportDetails);
      setTableEnable(true);
      setReportColumns(Object.keys(RestorationStore.reportDetails[0]));
    }else{
      HandleClear();
      toast.error('Sorry, No Data')
    }
    setFileName(`${downloadName}_${title}`)
  }
  return (
    <>
      <div className="title-wise-table">
        <Header>{name}</Header>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {DualInut && <>
            <h4
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingRight: '20px',
                paddingTop: '10px',
              }}
            >
              Report Type
            </h4>
            <Select
              placeholder="Report Type"
              filter
              selection
              search
              clearable
              options={reportTypeOptions}
              onChange={reportTypeAssign}
            />
          </>}
            {
              DualInut && reportTypeValue === 'Title Wise' &&(
                <div style={{ display: 'flex', alignItems: 'center' }}>
                <h4
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    paddingRight: '20px',
                    paddingTop: '10px',
                    paddingLeft: '20px',
                  }}
                >
                  Title Code{' '}
                </h4>
                <Select
                  style={{ display: 'flex', alignItems: 'center' }}
                  placeholder="Select Title code"
                  filter
                  Selection
                  search
                  clearable
                  options={assingTitleCode}
                  onChange={(_event, data) =>titleBasedDataLoad(data.value as string)}
                />
              </div>
              )
            }
            {(DateInput || (DualInut && reportTypeValue === 'Date Wise')) ?  <>
              <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                <h4>From Date</h4>
                <DatePicker
                  className='Table-DatePicker'
                  selected={fromDate}
                  onChange={(date) => setFromDate(date as Date)}
                  dateFormat="MM/dd/yyyy"
                  maxDate={new Date()}
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                <h4>To Date</h4>
                <DatePicker
                  className='Table-DatePicker'
                  selected={toDate}
                  onChange={(date) => setToDate(date as Date)}
                  dateFormat="MM/dd/yyyy"
                  maxDate={new Date()}
                  minDate={fromDate}
                />
              </div>
              {
           clusterEmployeeIdFilter && <>
           <Select
                  style={{ display: 'flex', alignItems: 'center',marginRight:'10px' }}
                  placeholder="Select Cluster EmployeeID"
                  filter  
                  Selection
                  search
                  clearable
                  options={clusterEmpDetails.options}
                  onChange={(_event:any, data:any) =>setClusterEmpDetails({...clusterEmpDetails,value:data?.value || ''})}
                />
           </>
          }
                <Button
                  primary
                  onClick={dateBasedDataLoad}
                  style={{ paddingLeft: '20px', paddingBottom: '10px' }}
                >
                  View Report
                </Button>
            </> : <></>}
           {loadData.length !== 0 && (
                <div style={(!DateInput && !DualInut) ? {position: 'absolute',right: '239px',top: '100px'} :{ textAlign: 'right',padding: '0 10px' }}>
                  <div></div>
                  <DynamicTableCSVReport
                    tableData={loadData}
                    tableName={name}
                    fileName={fileName}
                  />
                </div>
              )}
        </div>
        <div>
          <br />
          {RestorationStore.restorationReportLoader ? <><LoadingComponent/></> : (
            <div>
              {loadData.length === 0 && !clusterEmployeeIdFilter ? null : <DynamicTable columns={reportColumns} data={loadData}tableEnable={tableEnable} noData={clusterEmployeeIdFilter || false}/>}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default observer(TableComponent);


const DynamicTable: React.FC<{ columns: string[]; data: TableData[],tableEnable:boolean,noData:boolean }> = ({ columns, data, tableEnable,noData}) => {
    return (
      <Table>
        <Table.Header>
          <Table.Row>
            {(tableEnable && columns.length > 0) ? columns.map((column, index) => (
              <Table.HeaderCell key={index}>{column}</Table.HeaderCell>
            )) :  noData ? <Table.HeaderCell style={{marginBottom:'15px'}}></Table.HeaderCell> : null}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {(tableEnable && data.length > 0) ? data.map((row:any, rowIndex:any) => (
            <Table.Row key={rowIndex}>
              {columns.map((column:any, colIndex:any) => (
                <Table.Cell key={`${rowIndex}-${colIndex}`}>{row[column]}</Table.Cell>
              ))}
            </Table.Row>
          )): noData ? <Table.Row style={{marginLeft:'20px',marginBottom:'15px'}}>&nbsp;&nbsp;Sorry, No Data</Table.Row> : null}
        </Table.Body>
      </Table>
    );
  };
  